import { render, staticRenderFns } from "./NoticeAfterLogin.vue?vue&type=template&id=78a225f6&scoped=true&"
import script from "./NoticeAfterLogin.vue?vue&type=script&lang=ts&"
export * from "./NoticeAfterLogin.vue?vue&type=script&lang=ts&"
import style0 from "./NoticeAfterLogin.vue?vue&type=style&index=0&id=78a225f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a225f6",
  null
  
)

export default component.exports